import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@famly/mf_input_button';
import { Stack } from '@famly/mf_layout_stack';
import { Box } from '@famly/mf_layout_box';
import RoutesMap from 'signin-app/routes/routes-map';
import translate from 'signin-app/helpers/translate';
import { HeaderLogoContainer } from 'signin-app/components/containers';
import { WhitelabelLogo } from 'signin-app/whitelabel/whitelabel-logo';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
export const PinHeader = ({ whitelabelConfiguration, centerElement }) => {
    const { isMobileLandscapeAndLarger } = useBreakpoints();
    return (_jsxs(Stack, { alignItems: "center", justifyContent: "space-between", flexDirection: isMobileLandscapeAndLarger ? 'row' : 'column', gap: 3, children: [_jsx(HeaderLogoContainer, { children: _jsx(WhitelabelLogo, { url: whitelabelConfiguration.LogoForWhiteBg, height: { base: '48px', tabletPortrait: '100px' } }) }), centerElement ? _jsx(Box, { children: centerElement }) : null, _jsx(Link, { to: RoutesMap.pin, children: _jsx(Button, { variant: "tertiary", text: translate('logOut'), icon: "logout" }) })] }));
};
